import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTimeout } from 'site-modules/shared/hooks/use-timeout';

const TEXT_MAP = [
  { text: 'Reviewing message…', timeout: 1000 },
  { text: 'Searching Edmunds…', timeout: 4000 },
  { text: 'Summarizing results…' },
];

export function ThinkingText({ isIterating = false }) {
  const [textIndex, setTextIndex] = useState(0);
  const [setTextTimeout] = useTimeout();

  useEffect(() => {
    const timeout = TEXT_MAP[textIndex]?.timeout;
    if (timeout) {
      setTextTimeout(() => {
        setTextIndex(prev => prev + 1);
      }, timeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textIndex]);

  return <i className="text-shine">{isIterating ? TEXT_MAP[textIndex]?.text : 'Thinking…'}</i>;
}

ThinkingText.propTypes = {
  isIterating: PropTypes.bool,
};
